export const ERROR_MESSAGES = {
  UNEXPECTED_ERROR: '予期せぬエラーが発生しました。\n管理者に連絡してください。',
  NETWORK_ERROR: 'ネットワークエラーが発生しました。ネットワーク接続を確認してください。',
  FILE_SIZE_LIMIT_ERROR_MESSAGE: 'PDFファイルと添付ファイルの合計が制限を超えています。ファイルサイズを確認してください。',
  SESSION_ERROR: 'このタブのセッションは無効となりました。\n続行するにはOKボタンをクリックしてください。',
  DUPLICATE_FILE_NAME_ERROR: 'ファイル名が重複しています。\nファイル名を変更して再アップロードしてください。',
  ALPHANUMERIC_ERROR: '半角英数記号のみ入力してください。',
  NUMERIC_ERROR: '半角数字のみ入力してください。',
  LENGTH_ERROR: '入力できる文字数を超えています。',
  DUPLICATE_TAG_ERROR: '値が重複しています。',
  DOCUMENT_FILE_NAME_LENGTH_ERROR: 'ファイル名は不正です。\nファイル名を80文字以下にしてください。',
};

export const STATUS_MESSAGES = {
  LOADING_DATA: 'データ読み込み中',
  NO_DATA: 'データがありません',
};
